import { enAdmin } from '../en';
import { frAdmin } from '../fr';
import { esAdmin } from '../es';
import { deAdmin } from '../de';

export const adminModuleTranslations = {
  en: enAdmin,
  fr: frAdmin,
  es: esAdmin,
  de: deAdmin,
} as const;

